import React from 'react';

import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

class PageNavigationTabs extends React.Component {

    render() {
        const { pageTabs, activeTabIndex, onTabClick } = this.props;
        return (
            <AppBar position="static" color="default">
                <Tabs value={activeTabIndex | 0} indicatorColor="secondary" textColor="primary" fullWidth>
                    {
                        pageTabs.map((el, key) => {
                            return <Tab key={key} label={el.label} onClick={event => onTabClick(el, key)} />;
                        })
                    }
                </Tabs>
            </AppBar>
        );
    }
}
export default PageNavigationTabs;


// WEBPACK FOOTER //
// ./src/Components/Presentation/_Shared/Layout/PageNavigationTabs.js